export const isModifierPressed = e => {
  const isMac = navigator.platform.toUpperCase().includes('MAC');

  return isMac ? e.metaKey : e.ctrlKey;
};
